(() => {
  const root = document.querySelector('[data-hyppe-sampler]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(root.querySelector('[data-sample-data]').textContent);
  const cap = 2, chosen = new Map(), inCart = new Map();
  const variants = new Map(data.variants.map(v => [String(v.id), v]));
  const base = window.Shopify?.routes?.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: data.currency }).format(cents / 100);
  const submit = root.querySelector('[data-sample-submit]'), status = root.querySelector('[data-sample-status]'), error = root.querySelector('[data-sample-error]'), retry = root.querySelector('[data-sample-retry]');
  let ready = false, busy = false;
  const showError = text => { error.textContent = text; error.hidden = !text; };
  function applyCart(cart) {
    inCart.clear();
    for (const item of cart.items || []) { const id = String(item.variant_id || item.id); inCart.set(id, (inCart.get(id) || 0) + item.quantity); }
  }
  function render() {
    let total = 0, count = 0, saving = 0;
    const summary = root.querySelector('[data-sample-summary]'); summary.replaceChildren();
    for (const card of root.querySelectorAll('[data-sample-option]')) {
      const id = card.dataset.sampleOption, v = variants.get(id), qty = chosen.get(id) || 0, existing = inCart.get(id) || 0;
      card.dataset.selected = qty > 0;
      card.querySelector('[data-sample-quantity]').textContent = qty;
      card.querySelector('[data-sample-step="-1"]').disabled = !ready || busy || qty === 0;
      card.querySelector('[data-sample-step="1"]').disabled = !ready || busy || !v.available || qty + existing >= cap;
      card.querySelector('[data-sample-remaining]').textContent = existing >= cap ? 'Limit reached in your cart' : existing ? `${existing} in cart · ${Math.max(0, cap-existing)} more allowed` : 'Limit 2 per order';
      if (qty) {
        total += qty * v.price; count += qty;
        saving += qty * Math.max(0, (Number(v.compareAtPrice) || 0) - v.price);
        const li = document.createElement('li'), title = document.createElement('span'), price = document.createElement('span');
        title.textContent = `${qty} × ${v.title.replace('Moist Pouches - ', '').replace('Energy Pouches', 'FEINE')}`;
        price.textContent = money(qty * v.price); li.append(title, price); summary.append(li);
      }
    }
    summary.hidden = count === 0; root.querySelector('[data-sample-empty]').hidden = count > 0;
    root.querySelector('[data-sample-total]').textContent = money(total);
    const savingsLine = root.querySelector('[data-sample-selection-saving]');
    savingsLine.hidden = saving <= 0;
    savingsLine.textContent = saving > 0 ? `You save ${money(saving)} (${Math.round(saving * 100 / (total + saving))}% off regular pricing)` : '';
    submit.disabled = !ready || busy || count === 0;
    submit.textContent = busy ? 'Adding your samples…' : count ? `Add ${count} sample ${count === 1 ? 'pack' : 'packs'} · ${money(total)}` : 'Add samples to cart';
  }
  async function getCart() {
    const response = await fetch(base + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw Error('We could not check your cart. Please try again.');
    return response.json();
  }
  async function refresh() {
    if (busy) return;
    ready = false; render(); retry.hidden = true;
    try {
      applyCart(await getCart()); ready = true;
      let clamped = false;
      for (const [id, q] of chosen) { const allowed = Math.max(0, cap-(inCart.get(id)||0)); if(q>allowed) {chosen.set(id,allowed);clamped=true;} }
      if(clamped) status.textContent = 'Your cart changed. Limit 2 of each sample option per order.';
      else status.textContent = 'Choose up to 2 of each option.';
      showError('');
    } catch(e) {showError(e.message);status.textContent='';retry.hidden=false;}
    render();
  }
  root.addEventListener('click', e => {
    const button = e.target.closest('[data-sample-step]'); if (!button || button.disabled || busy) return;
    const id = button.closest('[data-sample-option]').dataset.sampleOption;
    chosen.set(id, Math.max(0, Math.min(cap-(inCart.get(id)||0), (chosen.get(id)||0)+Number(button.dataset.sampleStep))));
    showError(''); status.textContent = 'Your sample selection is updated.'; render();
  });
  retry.addEventListener('click', refresh);
  submit.addEventListener('click', async () => {
    if (busy || !ready || submit.disabled) return;
    busy = true; showError(''); render();
    let added = false;
    try {
      applyCart(await getCart());
      const items = [...chosen].filter(([,quantity]) => quantity > 0).map(([id,quantity]) => ({id:Number(id),quantity}));
      if (!items.length) throw Error('Choose a sample pack first.');
      if(items.some(item => item.quantity+(inCart.get(String(item.id))||0)>cap)) {
        for(const item of items) chosen.set(String(item.id),Math.max(0,cap-(inCart.get(String(item.id))||0)));
        throw Error('Limit 2 of each sample option per order. Your selection now accounts for the samples already in your cart.');
      }
      const drawer = document.querySelector('cart-drawer'), sections = drawer?.getSectionsToRender?.().map(s=>s.id) || ['cart-drawer','cart-icon-bubble'];
      const response = await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections,sections_url:location.pathname})});
      const result = await response.json();
      if(!response.ok || result.status) throw Error(typeof result.description === 'string' ? result.description : 'We could not add these samples. Your selection is saved. Please try again.');
      added = true;
      for(const item of items) inCart.set(String(item.id),(inCart.get(String(item.id))||0)+item.quantity);
      chosen.clear(); root.querySelector('[data-sample-cart]').hidden=false; status.textContent='Your samples are in the cart.';
      try {
        if(drawer && result.sections && Object.values(result.sections).some(Boolean)) {drawer.classList.remove('is-empty');drawer.renderContents(result);}
        else location.assign(base+'cart');
      } catch { location.assign(base+'cart'); }
    } catch(e) {
      showError(e.message); status.textContent=added?'Your samples were added. Open your cart to continue.':'Your selection is saved.';
    } finally {busy=false;render();}
  });
  window.addEventListener('pageshow',e=>{if(e.persisted)refresh();});
  window.addEventListener('focus',()=>{if(ready&&!busy)refresh();});
  refresh();
})();
